import React from 'react'
import Popup from './Popup';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import ErrorBoundary from './ErrorBoundary';
import FacilityPopup from './FacilityPopup';
import db from './db';

// MoveHubPopup component
export default class MoveHubPopup extends React.Component {

// initialize the MoveHubPopup Component
constructor(props) {
    super(props);
    this.state = {
        facility:Object.assign({}, FacilityPopup.emptyFacility),
        inventoryHubs:[],
        hubPopupPost:{ facility_id: 0},
        moveHubPopupVisible : false,
        moveHubPopupPostModified : false,
        moveHubPopupName : ""
    };
}

    // update list of inventory hubs
    componentDidUpdate(prevProps) {
        if(this.state.inventoryHubs.length===0 && this.props.visible){
            db.getFacility( 
                FacilityPopup.inventoryFacilityId,
                this.props.securityObject, async (res)=>{
                await res;
                let inventoryHubs=[];
                try{
                    inventoryHubs=res.hubs;
                } catch(e){}
                this.setState({
                    inventoryHubs:inventoryHubs
                })
            })
        }
    }

    // render
    render() {
        return(true) ? (
            <Popup className="move-hub-popup" trigger={ this.props.visible }  >
                <div className="align-right">
                    <button className="close-btn" onClick={() => this.closeMoveHubPopup() }>Close</button>
                </div>
                <h3>Move Hub from Inventory to {this.props.facility.facility_name}</h3>
                <TableScrollbar height="300px">
                    <ErrorBoundary>
                            <Table columns={[
                                        { title: 'ID', key: 'id', width :15 }
                                        ,{ title:'Host Name', key: 'hostname', width :80 }
                                        ,{ title:'Name', key: 'display_name', width :80 }
                                        ]} 
                                        dataSource={this.state.inventoryHubs}
                                        onRowClick={this.moveHubSelectHub.bind(this)} />
                    </ErrorBoundary>
                </TableScrollbar>
                <br />
                <button disabled={!this.state.moveHubPopupPostModified} className="" onClick={() => this.closeMoveHubPopup() }>Close</button>
                <button disabled={!this.state.moveHubPopupPostModified} className="" onClick={() => this.saveMoveHub() }>Save</button>    
                {this.state.hubPopupPost.id} / {this.state.hubPopupPost.facility_id} / {this.state.moveHubPopupName}
            </Popup>  
        ):"";
    }

    // select a hub to move
    moveHubSelectHub(row){ 
        let hubPopupPost=this.state.hubPopupPost;
        hubPopupPost.id = row.id;        
        hubPopupPost.facility_id=this.props.facility.id;
        this.setState({
            moveHubPopupPostModified:true,
            moveHubPopupName:row.hostname+" "+row.name,
            hubPopupPost:hubPopupPost
        });        
    }

    // close the popup
    closeMoveHubPopup(){
        if(this.state.moveHubPopupPostModified){
            if (window.confirm("The screen has been modifies.  Would you like to exit without saving changes?") === true) {
                this.close();
                } 
        } else {
            this.close();
        }
    }    
    // close popup
    close(){
        this.props.onCloseMoveHubPopup();
        this.setState({
            moveHubPopupVisible: false
            ,moveHubPopupName:""
            ,inventoryHubs:[]
        });
    }


    // save the move hub
    saveMoveHub(){
        let thisApp=this;
        db.saveData( this.props.securityObject
                        , this.state.hubPopupPost
                        , "api/moveHub"
                        , function(){                         
                            thisApp.close();
                        });
    }

// open move a hub popup
moveHub(obj){
    this.setState({
        moveHubPopupVisible:true,
        moveToFacility:`${this.state.facility.facility_name} ( ${this.state.facility.id} ),`,
        moveHubPopupName:"",
        hubPopupPost:{ facility_id: this.state.facility.id}
    });
}    
}

